export let ZonosCurrency = /*#__PURE__*/function (ZonosCurrency) {
  ZonosCurrency["USD"] = "USD";
  ZonosCurrency["EUR"] = "EUR";
  ZonosCurrency["GBP"] = "GBP";
  ZonosCurrency["NOK"] = "NOK";
  return ZonosCurrency;
}({});
var ZonosExcludeItemTaxOption = /*#__PURE__*/function (ZonosExcludeItemTaxOption) {
  ZonosExcludeItemTaxOption["exclude"] = "exclude";
  return ZonosExcludeItemTaxOption;
}(ZonosExcludeItemTaxOption || {});
var ZonosWeightUnits = /*#__PURE__*/function (ZonosWeightUnits) {
  ZonosWeightUnits["lbs"] = "lbs";
  ZonosWeightUnits["oz"] = "oz";
  ZonosWeightUnits["kg"] = "kg";
  return ZonosWeightUnits;
}(ZonosWeightUnits || {});
var CountryOfOriginSource = /*#__PURE__*/function (CountryOfOriginSource) {
  CountryOfOriginSource["zonosCatalog"] = "zonos_catalog";
  CountryOfOriginSource["apiRequest"] = "api_request";
  CountryOfOriginSource["accountDefault"] = "account_default";
  return CountryOfOriginSource;
}(CountryOfOriginSource || {});
export let ZonosDeliveryDutyOptions = /*#__PURE__*/function (ZonosDeliveryDutyOptions) {
  ZonosDeliveryDutyOptions["DDP"] = "delivery_duty_paid";
  ZonosDeliveryDutyOptions["DDU"] = "delivery_duty_unpaid";
  return ZonosDeliveryDutyOptions;
}({});
var ZonosSaleTypes = /*#__PURE__*/function (ZonosSaleTypes) {
  ZonosSaleTypes["notForResale"] = "not_for_resale";
  ZonosSaleTypes["forResale"] = "for_resale";
  return ZonosSaleTypes;
}(ZonosSaleTypes || {}); // from docs: only required for Canada and Brazil
export let ZonosTariffRates = /*#__PURE__*/function (ZonosTariffRates) {
  ZonosTariffRates["maximum"] = "maximum";
  ZonosTariffRates["median"] = "median";
  ZonosTariffRates["minimum"] = "minimum";
  ZonosTariffRates["zonosPreferred"] = "zonos_preferred";
  return ZonosTariffRates;
}({}); // we should use this

// here number is not cents, but dollars 142 => 1.42

export let ZonosDeMinimisThreshold = /*#__PURE__*/function (ZonosDeMinimisThreshold) {
  ZonosDeMinimisThreshold["above"] = "above";
  ZonosDeMinimisThreshold["below"] = "below";
  return ZonosDeMinimisThreshold;
}({});
export let ZonosCurrencyRateTypes = /*#__PURE__*/function (ZonosCurrencyRateTypes) {
  ZonosCurrencyRateTypes["MID_MARKET"] = "MID_MARKET";
  ZonosCurrencyRateTypes["GUARANTEED"] = "GUARANTEED";
  return ZonosCurrencyRateTypes;
}({}); // is the rate type for customers on Zonos Payments or International Checkout.
export * from './bulk-classify.request';
export * from './bulk-classify.response';
export * from './classify-item.response';
export * from './classify-item.request';
export * from './order-complete.request';
export * from './order-complete.response';